import moment from 'moment';

export const displayInEasternTime = (date, format) => {
  return moment(
    new Date(date).toLocaleString('en-CA', {
      timeZone: 'America/Toronto',
    }),
    'YYYY-MM-DD'
  ).format(format);
};
